import React, { Component } from 'react';
import  {Container, Segment, Icon, Button, Modal, Header}  from 'semantic-ui-react'
import { Link } from "react-router-dom"
import API from '../../../services/Api'

class ConnectedGetUser extends Component {
    constructor(props){
        super(props);

        this.state = {};

        // this.handleChangeId = this.handleChangeId.bind(this);
        // this.handleChangeEmail = this.handleChangeEmail.bind(this);
        // this.handleSubmitId = this.handleSubmitId.bind(this);
        // this.handleSubmitEmail = this.handleSubmitEmail.bind(this);
    }

    // handleSubmitId(event){
    //     event.preventDefault();
        
    //     var xdr = new XMLHttpRequest(); 
    //     xdr.responseType = 'json';
    //     xdr.open("GET", this.props.app.dns+'/admin/user/id/'+this.state.id, true);
    //     xdr.setRequestHeader("Authorization", "Bearer "+this.props.app.token);

    //     xdr.send();
    //     xdr.onload = () =>{
    //         var response = xdr.response;
    //         this.setState({
    //             response: xdr.response
    //         })
    //     }

    //     xdr.onerror = () => {
    //         this.setState({
    //             error: "Erreur"
    //         })
    //     }
        
        
    // }
    // handleChangeId(event) {
    //     this.setState({id: event.target.value});
    // }

    // handleSubmitEmail(event){
    //     event.preventDefault();
        
    //     var pwd = this
    //     var xdr = new XMLHttpRequest(); 
    //     xdr.responseType = 'json';
    //     xdr.open("GET", this.props.app.dns+'/admin/user/email/'+this.state.email, true);
    //     xdr.setRequestHeader("Authorization", "Bearer "+this.props.app.token);

    //     xdr.send();
    //     xdr.onload = function() {
    //         var response = xdr.response;
    //         pwd.setState({
    //             response: response
    //         })
    //     }

    //     xdr.onerror = () => {
    //         pwd.setState({
    //             error: xdr.error
    //         })
    //     }
        
    // }
    // handleChangeEmail(event) {
    //     this.setState({email: event.target.value});
    // }

    componentWillMount() {
        API.getClients().then(res => {
            var allClients = res.data.users
            this.setState({
                allClients
            })
        })
    }

    deleteClient = (userId, index) => {
        API.deleteClient(userId).then(res => {
            var tabCopy = this.state.allClients;
            tabCopy.splice(index, 1);
            this.setState({
                allClients : tabCopy,
                modalOpen : false
            })
        })
    }

    handleOpen = (user, index) => this.setState({ modalOpen: true, currentClient: user, currentIdx: index })

    handleClose = () => this.setState({ modalOpen: false })

    render() {
        // if(this.state.error !== null){
                
            return(
                
                <Container>
                    <div className="ui center aligned container">
                        <br/>
                        <h1 className="ui header">User Area</h1>
                        <h2 className="ui header">Get</h2>
                        <br/>
                        <Segment basic >
                            <Link to='/comptes/addUser'>
                                <Button  primary floated='right'>Créer</Button>
                            </Link>
                        </Segment>
                    </div>
                    <Segment basic>
                        {(this.state.allClients || []).map((client,index) => <Segment>{client.name}
                        <Link to={`/comptes/update/${client.id}`}>
                            <Icon 
                                circular 
                                name='edit' 
                                color="teal" 
                                className="actionIcon" 
                                onClick={()=> {}} 
                                floated='right'
                            />
                        </Link>
                        <Icon 
                            circular 
                            name='trash alternate'  
                            color='red' 
                            className="actionIcon" 
                            onClick={() => this.handleOpen(client, index)} 
                            floated='right'
                        />
                        </Segment>)}
                    </Segment>
                    <Modal open={this.state.modalOpen} >
                        <Header icon='exclamation' content='Confirmer la suppression' />
                        <Modal.Content>
                            <p>
                                Etes sur de vouloir supprimer ?
                            </p>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button color='red' onClick={this.handleClose} >
                                <Icon name='remove' /> No
                            </Button>
                            <Button color='green' onClick={() => this.deleteClient(this.state.currentClient.id, this.state.currentIdx)}>
                                <Icon name='checkmark' /> Yes
                            </Button>
                        </Modal.Actions>
                    </Modal>
                
                   
                    </Container>
            )
                
                   
            // )
        // }
        
    }
}

const GetUser = (ConnectedGetUser);

export default GetUser;



// WEBPACK FOOTER //
// ./src/components/Protected/User/ListesComptes.jsx